// --------------------------------------------------------
// src/bootstrap.js
//
// This is the glue for the components of the application.
// This starts this application and loads the routes from
// the router.
//
// --------------------------------------------------------
"use strict";

// Add animation to the preloader
const loadingTl = new TimelineMax().staggerTo("#preloader h1.animated-dots", 1, { y: -7, yoyo: true, repeat: -1, ease: Power4.easeIn }, 0.2);

// Hide the preloader once the page is loaded
window.onload = function() {
  $("#preloader").fadeOut(750);
  loadingTl.repeat(1);
};

// Create an collection of books that will be accessible
// everywhere in the application
window.BOOKCOLLECTION = new BookCollection(BookRepository.getArrBooks()).randomize();
window.THEMECOLLECTION = new ThemeCollection(BookRepository.getArrThemes());

// Initialize the application with its base components
app.init();

// Create the Router
app.router = new ReadsRouter();
// Start the Router
Backbone.history.start();